export const ReimbursemntActionItems = Object.freeze({
    ViewClaims: "ViewClaims",
    ApproveClaims: "ApproveClaims",
    RejectClaims: "RejectClaims",
    CancelClaims: "CancelClaims",
    EditClaims: "EditClaims",
    AddClaims: "AddClaims",
})